// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3LT8p","label":"Radio_label__1Aoqf","checkMark":"Radio_checkMark__Mqv0x","disabled":"Radio_disabled__yF69q"};